import React, { useMemo, useState } from "react";
import _ from "lodash";

import constants from "../../config/constants";
import LogsService from "../../utils/logs";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import CardPreviewImage from "./common/CardPreviewImage";
import CardContent from "./common/CardContent";
import CardFilterPills from "./common/CardFilterPills";
import AudioPlayer from "../common/AudioPlayer";
import CardFooter from "./common/CardFooter";
import ShortFeedItem from "../common/ShortFeedItem";
import VideoEmbed from "./common/VideoEmbed";
import getEnvEndpoints from "../../utils/endpoints";
import { previewImageOfPost, mtStandardsBooks } from "../../utils/helper";

const endpoints = getEnvEndpoints();

const MultiMedia = ({
  post,
  lookup,
  showPmbokModal,
  showShareModal,
  showFeedbackModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  playlists,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = async () => {
    if (!canProceed()) return;

    if (!expanded) {
         if (post.isPublic && post.publishUntilDate && !((post.isPublic) && (new Date (post.publishUntilDate) > new Date()) )) {
        await LogsService.logViewItem({
          contentKey: post.contentKey,
          contentSubType: post.contentType,
        })
          .then(() => { })
          .catch(() => { });
      }
    }

    setExpanded(!expanded);
  };

  const audioMedia = useMemo(() => {
    return _.find(post.referenceFiles, {
      fileKey: constants.fileKey.audioMedia,
    });
  }, [post.referenceFiles]);

  const videoMedia = useMemo(() => {
    return _.find(post.referenceFiles, {
      fileKey: constants.fileKey.videoMedia,
    });
  }, [post.referenceFiles]);

  const getAudioUrl = (audioMedia) => audioMedia.filePath;

  const link = () => videoMedia.fileFormat === constants.fileFormat.link;
  const brightcove = () =>
    videoMedia.fileFormat === constants.fileFormat.brightcove;

  const getVideoUrl = () => {
    return videoMedia.filePath;
  };
  const previewImage = previewImageOfPost(post);

  return (
    <>
      {fullcard ? (
        <div
          className={
            "flex border border-gray-500 rounded-sm mb-5 " +
            (post.status !== "Published" ? "bg-gray-400" : "bg-white")
          }
        >
          <div className="w-full">
            <CardHeader
              post={post}
              showPmbokModal={showPmbokModal}
              canProceed={canProceed}
              booksList={mtStandardsBooks(lookup, "MTStandardsGuide")}
            />

            <div className="px-5 mt-4">
              <div className="cursor-pointer" onClick={toggleExpand}>
                <CardSubheader subheader={post.title} />
              </div>
              {previewImage && !videoMedia && (
                <div className="cursor-pointer" onClick={toggleExpand}>
                  <CardPreviewImage previewImage={previewImage?.filePath || previewImage} />
                </div>
              )}

              {videoMedia && (
                <>
                  {brightcove() ? (
                    <VideoEmbed className="mb-5" url={getVideoUrl()} />
                  ) : (
                    <video className="mb-5 block w-full" controls>
                      <source src={getVideoUrl()} type="video/mp4" />
                    </video>
                  )}
                </>
              )}

              {audioMedia && (
                <AudioPlayer
                  url={getAudioUrl(audioMedia)}
                  canProceed={canProceed}
                  post={post}
                />
              )}

              <CardContent
                post={post}
                isExpandable={true}
                expanded={expanded}
                setExpanded={toggleExpand}
              />

              <CardFilterPills
                post={post}
                lookup={lookup}
                canProceed={canProceed}
                cardFilterSelected={cardFilterSelected}
              />
            </div>

            <CardFooter
              post={post}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              canProceed={canProceed}
              isAuthenticated={isAuthenticated}
              playlists={playlists}
              propGroup={propGroup}
              userLikes={userLikes}
              feedbacks={feedbacks}
              contentKey={contentKey}
              id={id}
            />
          </div>
        </div>
      ) : (
        <ShortFeedItem post={post} />
      )}
    </>
  );
};

export default MultiMedia;
